import CardGrid from '../components/CardGrid';
import { hotels } from '../data/hotels';

export default function Hotels() {
  const items = hotels.map(h => ({ ...h, cta: h.cta || { label: 'Request Rates', href: '/contact' } }));
  return (
    <section className="section">
      <h2>Hotels & Resorts</h2>
      <p className="muted">From luxury resorts to boutique hotels and budget stays.</p>
      <CardGrid items={items} />
    </section>
  );
}
